import { createRoute, redirect } from "@tanstack/react-router";

import { DEFAULT_ROUTE, PRIMARY_ROUTES } from "@zentrack/config";
import { __rootRoute } from "./__root";
import { getWebApi } from "../app/app-provider";

/**
 * Index route. Redirects to the persisted last route (when it is a known
 * primary route) or the default route. Resolved in `beforeLoad` so the redirect
 * happens during the route lifecycle rather than being thrown from component
 * render, which avoids relying on render-time redirect behavior.
 *
 * If the database cannot be opened (e.g. unsupported browser), we fall back to
 * the default route — the app shell surfaces the underlying error.
 */
export const indexRoute = createRoute({
  getParentRoute: () => __rootRoute,
  path: "/",
  beforeLoad: async () => {
    const target = await resolveHomeTarget();
    throw redirect({ to: target, replace: true });
  },
});

const VALID_HOME_ROUTES = new Set<string>(PRIMARY_ROUTES.map((route) => route.href));

async function resolveHomeTarget(): Promise<string> {
  try {
    const api = await getWebApi();
    const settings = await api.settings.get();
    return VALID_HOME_ROUTES.has(settings.lastRoute) ? settings.lastRoute : DEFAULT_ROUTE;
  } catch {
    return DEFAULT_ROUTE;
  }
}
